export default __webpack_public_path__ + "static/media/Brief Report by The Chief of 1st WCHSS.cc0f319d.JPG";